export function resolveStablePreviewStream(
  currentStableStream: MediaStream | null,
  nextPreviewStream: MediaStream | null,
) {
  if (!nextPreviewStream) return null;
  if (!currentStableStream) return nextPreviewStream;

  const currentTrack = currentStableStream.getVideoTracks?.()[0];
  const nextTrack = nextPreviewStream.getVideoTracks?.()[0];

  if (!currentTrack) return nextPreviewStream;
  if (!nextTrack) return currentStableStream;

  const isCurrentTrackInactive =
    !currentStableStream.active || currentTrack.readyState === 'ended';
  const isNextTrackActive =
    nextPreviewStream.active && nextTrack.readyState !== 'ended';

  if (isCurrentTrackInactive && isNextTrackActive) {
    return nextPreviewStream;
  }

  if (isNextTrackActive && currentTrack.id !== nextTrack.id) {
    return nextPreviewStream;
  }

  return currentStableStream;
}
